import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgResult(props) {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_jsx("mask", Object.assign({
      id: "result_svg__a",
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 64,
      height: 64
    }, {
      children: _jsx("path", {
        fill: "#fff",
        d: "M0 0h64v64H0z"
      }, void 0)
    }), void 0), _jsxs("g", Object.assign({
      mask: "url(#result_svg__a)"
    }, {
      children: [_jsx("path", {
        d: "M24.152 29.561a1.5 1.5 0 10-2.304 1.92l2.304-1.92zM28 36.521l-1.152.96a1.5 1.5 0 002.213.101L28 36.522zm12.06-9.939a1.5 1.5 0 00-2.12-2.121l2.12 2.121zm-18.212 4.9l5 6 2.304-1.92-5-6-2.304 1.92zm7.213 6.1l11-11-2.122-2.121-11 11 2.122 2.121z",
        fill: "#FF6652"
      }, void 0), _jsx("path", {
        d: "M53.5 35.585a1.5 1.5 0 01-3 0h3zM29.163 56.5a1.5 1.5 0 010 3v-3zm10.101-51H12.326v-3h26.938v3zM11.5 6.326v49.348h-3V6.326h3zm38.623 9.464L40.17 5.874l2.117-2.125 9.953 9.916-2.117 2.125zm.377 19.795V16.699h3v18.886h-3zM12.326 56.5h16.837v3H12.326v-3zM52.24 13.665a4.283 4.283 0 011.26 3.034h-3c0-.341-.136-.668-.377-.909l2.117-2.125zM11.5 55.674c0 .456.37.826.826.826v3A3.826 3.826 0 018.5 55.674h3zM12.326 5.5a.826.826 0 00-.826.826h-3A3.826 3.826 0 0112.326 2.5v3zm26.938-3c1.133 0 2.22.449 3.023 1.249L40.17 5.874a1.283 1.283 0 00-.906-.374v-3z",
        fill: "#7373FF"
      }, void 0), _jsx("path", {
        d: "M51 16.025h-8.674A2.326 2.326 0 0140 13.699V5.025",
        stroke: "#7373FF",
        strokeWidth: 3,
        strokeLinecap: "round"
      }, void 0), _jsx("path", {
        d: "M48.373 55.146L47.3 54.097l1.073 1.049zm4.647 5.99a1.5 1.5 0 001.96-2.272l-1.96 2.272zm-11.053-4.793c-4.12 0-7.467-3.349-7.467-7.487h-3c0 5.789 4.683 10.487 10.467 10.487v-3zM34.5 48.856c0-4.138 3.346-7.487 7.467-7.487v-3c-5.784 0-10.467 4.698-10.467 10.487h3zm7.467-7.487c4.121 0 7.468 3.35 7.468 7.487h3c0-5.789-4.684-10.487-10.468-10.487v3zm7.468 7.487c0 2.042-.813 3.89-2.135 5.241l2.145 2.097a10.468 10.468 0 002.99-7.338h-3zM47.3 54.097a7.43 7.43 0 01-5.333 2.246v3c2.93 0 5.58-1.208 7.478-3.149L47.3 54.097zm.093 2.184l5.627 4.855 1.96-2.272-5.627-4.854-1.96 2.271z",
        fill: "#FF6652"
      }, void 0)]
    }), void 0)]
  }), void 0);
}

export default SvgResult;